import React, { useState } from 'react'
import { Checkbox, Collapse} from 'antd';
import { RARITY } from '../../Statics/Rarity';
import "./FilterProducts.css"
import { PokemonSet } from '../../Models/PokemonSet';

interface Props{

  selectedSets: string[]
  setSelectedSets: React.Dispatch<React.SetStateAction<string[]>>
  selectedTypes: string[]
  setSelectedTypes: React.Dispatch<React.SetStateAction<string[]>>
  loading?: boolean
  sets:PokemonSet[]
}

const FilterSectionPokemonMovil = ({selectedSets,setSelectedSets, setSelectedTypes, selectedTypes, loading, sets}:Props) => {

const handleChange = (checkedValues: any) => {
    setSelectedTypes(checkedValues);
    // Aquí puedes disparar la lógica de filtro o una función de callback
  };

  const handleChangeSet = (checkedValues: any) => {
    setSelectedSets(checkedValues);
    // Aquí puedes disparar la lógica de filtro o una función de callback
  };
  return (
    <div className='filter-Products-container'>
    <div className='FilterSection-PokemonMovil'>
            <Collapse
              defaultActiveKey={['1']}
            items={[{ key: '1', label: 'Rareza', children: <div className='filter-pokemon-movil-collapse' > 
                <Checkbox.Group
                options={RARITY}
                value={selectedTypes}
                onChange={handleChange}
                style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: '8px' 
                }}
                />

            </div> }]}/>

    </div>

    <div className='FilterSection-PokemonMovil'>
            <Collapse
              defaultActiveKey={['1']}
            items={[{ key: '1', label: 'Sets', children: <div className='filter-pokemon-movil-collapse' > 
                <Checkbox.Group
                options={sets.map(set => ({
    label: set.name,
    value: set.id,
  }))}
                value={selectedSets}
                onChange={handleChangeSet}
                style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: '8px' 
                }}
                />

            </div> }]}/>

    </div>

    


    </div>
  )
}

export default FilterSectionPokemonMovil